//Taken from project dataedxplorer branch: WYDE30 location: \RBDMSGIS\Scripts\RBDMSGIS_HTML_OL.js Function formatLength
export const convertMeasureArea = (area, areaUnit) => {
    let output
    switch (areaUnit) {
        case "us":
            // convert to square feet
            area = area / 0.09290304;
            if (area > 43560) {
                output = `${Math.round(area / 43560 * 100) / 100} ac`;
            } else {
                output = `${Math.round(area * 100) / 100} ft<sup>2</sup>`;
            }
            break;
            
        case "metric":
            if (area > 1000000) {
                output = `${Math.round(area / 1000000 * 100) / 100} km<sup>2</sup>`;
            } else {
                output = `${Math.round(area * 100) / 100} m<sup>2</sup>`;
            }
            break;
            
        case "ft2":
            area = area / 0.09290304;
            output = `${Math.round(area * 100) / 100} ft<sup>2</sup>`;
            break;
            
        case "ac":
            area = area / 0.09290304;
            output = `${Math.round(area / 43560 * 100) / 100} ac`;
            break;
            
        case "m2":
            output = `${Math.round(area * 100) / 100} m<sup>2</sup>`;
            break;
            
        case "km2":
            output = `${Math.round(area / 1000000 * 100) / 100} km<sup>2</sup>`;
            break;
            
        default:
            // Handle unknown unit (could default to metric)
            if (area > 1000000) {
                output = `${Math.round(area / 1000000 * 100) / 100} km<sup>2</sup>`;
            } else {
                output = `${Math.round(area * 100) / 100} m<sup>2</sup>`;
            }
    }
    return output
}

export default (length, distanceUnit) => {
    let output
    switch (distanceUnit) {
        case "us":
            // Convert to feet
            length = length / 0.3048;
            if (length > 5280) {
                output = `${Math.round(length / 5280 * 100) / 100} mi`;
            } else {
                output = `${Math.round(length * 100) / 100} ft`;
            }
            break;
    
        case "feet":
            length = length / 0.3048;
            output = `${Math.round(length * 100) / 100} ft`;
            break;
    
        case "miles":
            length = length / 0.3048;
            output = `${Math.round(length / 5280 * 100) / 100} mi`;
            break;
    
        case "meters":
            output = `${Math.round(length * 100) / 100} m`;
            break;
    
        case "kilometers":
            output = `${Math.round(length / 1000 * 100) / 100} km`;
            break;

        default:
            if (length > 1000) {
                output = `${Math.round(length / 1000 * 100) / 100} km`;
            } else {
                output = `${Math.round(length * 100) / 100} m`;
            }
            break;
    }
    return output
}